// extracted by mini-css-extract-plugin
export default {"container":"RootLayout_container__TXnUS","mainLogin":"RootLayout_mainLogin__oiURR"};